// PathTracker.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent, trackPageViewed } from "../lib/mixpanel";
import { gaPageView } from "../utils/gaAnalytics";
import { isLegacyCheckoutPath, sanitizePath } from "../utils/sanitizePath";

function PathTracker() {
  const location = useLocation();

  useEffect(() => {
    // pathHistory is what PublicRoute navigates back to after login, so it
    // keeps real paths — except the legacy checkout URL, whose path is the
    // Stripe client secret and must never be persisted.
    if (!isLegacyCheckoutPath(location.pathname)) {
      let history = JSON.parse(localStorage.getItem("pathHistory")) || [];

      history.push(location.pathname);

      if (history.length > 5) {
        history = history.slice(history.length - 5);
      }

      localStorage.setItem("pathHistory", JSON.stringify(history));
    }

    // Analytics only ever see the route template for parameterised routes
    // (e.g. "/checkout/:checkoutToken"), never the actual token or secret.
    const safePath = sanitizePath(location.pathname);
    trackPageViewed(safePath);
    gaPageView(safePath + location.search);
    if (location.pathname === "/pricing") {
      trackEvent("paywall_viewed");
    }
  }, [location]);

  return null;
}

export default PathTracker;
